/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Templateid1Inputs */

const en_entity_templateid1 = /** @type {(inputs: Entity_Templateid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template ID`)
};

const de_entity_templateid1 = /** @type {(inputs: Entity_Templateid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template-ID`)
};

/**
* | output |
* | --- |
* | "Template ID" |
*
* @param {Entity_Templateid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_templateid1 = /** @type {((inputs?: Entity_Templateid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Templateid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_templateid1(inputs)
	return de_entity_templateid1(inputs)
});
export { entity_templateid1 as "entity_templateId" }